<template>
  <div class="background-wrapper" v-if="productData">
    <div class="intro_content container">
      <v-col cols="12">
        <h1
          class="text-light anim-title mg-0 intro__title heading-one is-shown"
        >
          {{ productData.prodCat_tagline }}
        </h1>
        <div class="video-container intro__video">
          <v-col class="col-md-8 offset-md-2">
            <div id="video-wrapper" class="video-teaser is-playing">
              <iframe
                v-if="isYouTubeVideo"
                id="ytplayer"
                type="text/html"
                width="100%"
                height="200px"
                :src="
                  `https://www.youtube.com/embed/${videoUrl}?autoplay=1&origin=http://example.com`
                "
                frameborder="0"
              ></iframe>

              <video
                width="100%"
                height="200px"
                id="vid"
                controls
                loop
                autoplay
                playsinline
                muted
                v-show="productData.productVideo && !isYouTubeVideo"
              >
                <source :src="`${productData.productVideo}`" type="video/mp4" />
              </video>
              <!-- <iframe
                class="video-teaser"
                :src="`${productData.productVideo}`"
                loop
                frameborder="0"
                allowfullscreen
                v-show="isProductVideoAvailable"
              ></iframe> -->
              <!-- <video width="450" controls>
                <source src="../src/assets/static/videos/videoplayback_Rebula_edi-simcic.mp4" type="video/mp4">
              </video> -->
            </div>
          </v-col>
        </div>
        <v-spacer></v-spacer>
      </v-col>
      <div id="cta-sticky">
        <!-- <span class="stock-info-text" v-if="productData.productCurrStock === 0">{{ productData.productName }} is <strong>out of stock</strong> now!!!</span>
        <span class="stock-info-text" v-else>Only <strong>{{ productData.productCurrStock }}</strong> left on stock!</span> -->
        <div style="width: 100%; margin-top: 10px">
          <AddToCart
            class="scanBuy notShippable"
            v-if="
              !productData.is_shippable &&
                allowToSell &&
                productData.productCurrStock
            "
            @open-modal="showNextModal"
            :subscription="subscription"
            :productData="productData"
          />
          <AddToCart
            class="scanBuy"
            v-if="
              productData.is_shippable &&
                allowToSell &&
                productData.productCurrStock
            "
            @open-modal="showNextModal"
            :subscription="subscription"
            :productData="productData"
          />
          <ShipToBtn
            class="shipTo"
            v-if="productData.is_shippable && productData.productCurrStock"
            @open-modal="showNextModal"
            :subscription="subscription"
          />
        </div>
      </div>
      <InfoAnimButton
        :email="productData.clientEmail"
        :contact="productData.clientContactNo"
      />
    </div>
    <v-row class="product-info">
      <v-col>
        <h1 class="product_title">{{ productData.productName }}</h1>
        <v-card class="d-inline-block mx-auto">
          <v-container>
            <v-row justify="space-between">
              <v-col cols="auto">
                <img
                  :src="`${productData.productImage}`"
                  height="auto"
                  width="200"
                  :alt="productData.productName"
                />
              </v-col>
              <v-col cols="auto" class="text-center pl-0">
                <v-row class="flex-column ma-0 fill-height" justify="center">
                  <!--ADD TO WISHLIST ICON TEMPORARY REMOVED
                    <v-col class="px-0">
                      <v-btn icon>
                        <v-icon>mdi-heart</v-icon>
                      </v-btn>
                    </v-col>¸  -->
                  <!--SHARE ICON TEMPORARY REMOVED
                    <v-col class="px-0">
                      <v-btn icon>
                        <v-icon>mdi-share-variant</v-icon>
                      </v-btn>
                    </v-col> -->
                </v-row>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <!-- END OF PRODUCT CARD -->
        <!-- <div class="rating">
          <v-rating
            class="secondary-gradient"
            v-model="product_rating"
          ></v-rating
          ><span class="ratingNo">
            4
          </span>
        </div> -->
        <pre
          class="description_text"
          data-aos="fade-up"
          data-aos-anchor-placement="center-bottom"
        >
          {{ productData.productDescription }}
        </pre>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <v-row class="price-section">
      <v-col>
        <v-col class="price-details">
          <span class="price">
            {{ productData.originalProductPrice }}
          </span>
          <span class="valuta">EUR</span>
          <div class="tax-details">(incl. of all taxes & fees)</div>
          <div style="margin: auto">
            <br />
            <span
              class="out-of-stock-info-text"
              v-if="productData.productCurrStock === 0"
              >{{ productData.productName }} is
              <strong>out of stock</strong> now!</span
            >
            <span
              class="stock-info-text"
              v-if="
                productData.productCurrStock > 0 &&
                  productData.productCurrStock < 10
              "
              >Only <strong>{{ productData.productCurrStock }}</strong> left in
              stock!</span
            >
          </div>
        </v-col>
        <v-spacer></v-spacer>
      </v-col>
    </v-row>
    <!-- STICK - GOT TO REVIEWS  -->

    <!-- <div id="scroll">
      <a href="#reviews"
        >GO TO<br />
        REVIEWS</a
      >
      <Br /> &#8681;
    </div> -->

    <!-- <v-row id="reviews" class="reviews">
      <v-col>
        <h1 class="product_reviews">Reviews</h1>
        <v-spacer></v-spacer>
        <v-divider class="divider"></v-divider>
        <v-spacer></v-spacer>
        <ProductReviews />
      </v-col>
    </v-row> -->
    <!--Multiple modal-->
    <div>
      <b-modal
        id="miniCart"
        size="lg"
        title="My Bag"
        @show="performBeforeOpenBag()"
        hide-footer
      >
        <ul id="example-1">
          <li
            class="mg-b50"
            v-for="(item, index) in this.cartData"
            :key="index"
          >
            <div>
              <b-img
                :src="`${item.img_path}`"
                width="200px"
                fluid
                rounded
                right
                class="myBagImg"
              />
            </div>

            <div class="media-body">
              <h5 class="mt-0">{{ item.name }}</h5>
              <p class="mt-0">{{ item.price }} EUR</p>
              <div class="mt-0">
                <form>
                  <div
                    class="value-button"
                    :key="`increase${index}`"
                    id="decrease"
                    @click="decreaseValue(index)"
                    value="Decrease Value"
                  >
                    -
                  </div>
                  <input
                    type="number"
                    :key="`number${index}`"
                    id="number"
                    v-model="item.quantity"
                    disabled
                  />
                  <div
                    class="value-button"
                    :key="`decrease${index}`"
                    id="increase"
                    @click="increaseValue(index)"
                    value="Increase Value"
                    :disabled="
                      itemsAvailability[index] !== undefined &&
                        itemsAvailability[index] === false
                    "
                  >
                    +
                  </div>
                  <div class="trashIcon" @click="removeItem(item.id, index)">
                    <font-awesome-icon class="icon" icon="trash" />
                  </div>
                </form>
                <span
                  class="stock-info-text-cart"
                  v-if="
                    itemsAvailability[index] !== undefined &&
                      itemsAvailability[index] === false
                  "
                  >Only <strong>{{ item.quantity }}</strong> left in
                  stock!</span
                >
              </div>
            </div>
          </li>
        </ul>
        <span class="shipping-info" v-if="shippingRate"
          >Shipping cost: <strong>{{ shippingRate.shipping_cost }} EUR</strong>
        </span>
        <br />
        <span class="shipping-info" v-if="shippingRate"
          >Est. date of delivery:
          <strong>{{ shippingRate.delivery_date }}</strong>
        </span>
        <br />
        <b-button class="cta-button" @click="openCheckoutModal()"
          >CHECKOUT</b-button
        >
        <b-button
          class="logout_btn"
          @click="
            $bvModal.show('continueShopping')
            $bvModal.hide('miniCart')
            updateQuantityInCartItems()
          "
          >CONTINUE SHOPPING</b-button
        >
      </b-modal>

      <b-modal
        id="loginModal"
        title="Login"
        size="lg"
        body-class="hide-padding"
        hide-footer
      >
        <LogInPage
          v-if="showLogin"
          :isChckoutLogin="isChckoutLogin"
          @login-response="loginResponse"
          @register-redirect="showRegister"
        ></LogInPage>
        <SignUpUser
          v-else
          :isChckoutRegister="isChckoutRegister"
          @register-response="registerResponse"
          @login-redirect="showLoginPage"
        ></SignUpUser>
      </b-modal>

      <b-modal
        id="continueShopping"
        size="lg"
        body-class="hide-padding"
        hide-footer
        title="Continue Shopping"
      >
        <h4>
          Open your camera, scan new QR code and add another item to your
          cart...
        </h4>
        <figure class="about-img2">
          <img src="../assets/static/images/illustrations/QRscanning2.svg" />
        </figure>
        <div>
          <button
            class="btn logout_btn"
            type="button"
            onclick="window.close();"
          >
            Close tab and open camera
          </button>
          <!-- <label for="files" class="btn logout_btn">OPEN CAMERA</label> -->
          <!-- <input id="files" style="visibility:hidden;" type="file" accept="image/*" capture="camera" /> -->
        </div>
      </b-modal>

      <b-modal id="checkout-modal" title="Checkout" hide-footer>
        <div class="checkout-container mt-5">
          <v-row>
            <ul>
              <li
                v-for="(item, index) in this.cartData"
                :key="index"
                class="media"
              >
                <img
                  :src="`${item.img_path}`"
                  width="80px"
                  class="align-self-center mr-3"
                  alt=""
                />
                <div class="media-body">
                  <h5 class="mt-0 productName">{{ item.name }}</h5>
                  <p class="mt-0">{{ item.price }} EUR</p>
                  <p class="mt-0">Quantity: {{ item.quantity }}</p>
                </div>
              </li>
            </ul>
          </v-row>
          <b-button class="logout_btn" @click="callBackToMyBag()">
            <font-awesome-icon class="icon" icon="chevron-left" />
            <span style="margin-left: 15px;">Back to "MY BAG"</span>
          </b-button>
          <br />
          <div style="margin-top:10px">
            <p class="shipping-info" v-if="shippingRate">
              Shipping cost:
              <strong>{{ shippingRate.shipping_cost }} EUR</strong>
            </p>
            <p class="shipping-info" v-if="shippingRate">
              Est. date of delivery:
              <strong>{{ shippingRate.delivery_date }}</strong>
            </p>
          </div>
          <v-col class="col-md-9 totalPriceLeft" v-if="totalPrice">
            <p class="my-2">
              TOTAL: <span class="totalPrice"> {{ totalPrice }}</span>
              <span class="totalPrice2"> EUR</span>
            </p>
          </v-col>
          <!-- <div v-if="isCartAlcoholic">
            <p>Age restriction warning</p>
          </div> -->
          <div class="left">
            <div class="disclaimer" v-if="isCartAlcoholic">
              <CheckMarkAnim18 @check-disclaimer="enablePayment" />
            </div>
            <div class="disclaimer">
              <CheckMarkAnimTC @check-disclaimer="enablePaymentCommon" />
            </div>
          </div>
          <StripePayment
            :productDetails="productData"
            :cartTotalPrice="totalPrice"
            :cartItems="cartData"
            :flow="type.flow"
            :disablePayment="disablePaymentFromDisclaimer"
            :disablePaymentCommon="disablePaymentDisclaimerCommon"
            :shippingRate="shippingRate"
            @success-response="showSuccessModal"
          ></StripePayment>
          <div class="stripeTrustBadge">
            <i class="fas fa-lock"></i>
            <span> Guaranteed <strong>safe & secure</strong> checkout</span>
            <img
              class="stripeIcon"
              src="../assets/static/icons/stripeTrustBadge.svg"
            />
            <img
              class="stripeCards"
              src="../assets/static/images/stripe_credit-cards.jpg"
            />
          </div>
          <div style="font-size: 0.65em; text-align: justify;">
            *Your personal data shall be processed by the above-mentioned seller
            as the controller of personal data and
            <a
              class="colorLink"
              target="_blank"
              href="https://linking-map.com/eng/"
            >
              Linking-Map d.o.o.
            </a>
            , namely the provider of the Expar platform, as the processor for
            the purposes of the sale and delivery (and all connected
            communication). Please see the
            <router-link
              target="_blank"
              class="colorLink"
              :to="'/' + 'PrivacyPolicy/' + $i18n.locale"
              >seller privacy policy
            </router-link>
            and the
            <a
              v-if="env === 'production'"
              class="colorLink"
              target="_blank"
              href="https://expar.si/politika-zasebnosti/"
            >
              Expar privacy policy
            </a>
            <a
              v-else
              class="colorLink"
              target="_blank"
              href="https://demo.expar.si/politika-zasebnosti/"
            >
              Expar privacy policy
            </a>
            , to learn more.
          </div>
        </div>
      </b-modal>

      <b-modal
        id="success-modal"
        title="Transaction Successful"
        hide-footer
        @close="paymentSucceed"
      >
        <div>
          <h2>Thanks for shopping!</h2>
          <br />
          <figure class="about-img2">
            <img
              src="../assets/static/images/illustrations/successPurchase.svg"
            />
          </figure>
          <br />
          <SuccessTickIconAnim
            v-if="showSuccessCheckmark"
            @perform-tick-click-action="$bvModal.hide('success-modal')"
          />
          <p
            v-if="
              paymentResponse &&
                shippingRate &&
                paymentResponse.amount &&
                paymentResponse.currency
            "
          >
            Your payment was successfull. Total amount paid
            <strong
              >{{ paymentResponse.amount }}
              {{ paymentResponse.currency }}</strong
            >
            from card {{ `xxxx xxxx xxxx ${paymentResponse.last4}` }}. Enjoy!
          </p>
          <p
            v-if="
              paymentResponse &&
                !shippingRate &&
                paymentResponse.amount &&
                paymentResponse.currency
            "
          >
            Your payment was successfull. Total amount paid
            <strong
              >{{ paymentResponse.amount }}
              {{ paymentResponse.currency }}</strong
            >
            from card {{ `xxxx xxxx xxxx ${paymentResponse.last4}` }}. Enjoy!
          </p>
          <br />
          <p v-if="shippingRate && shippingDetails">
            Your order is arriving on
            <strong>{{ shippingRate.delivery_date }}</strong> at
            {{ shippingDetails.address }}
          </p>
          <!-- <b-button class="logout_btn" @click="paymentSucceed">DONE</b-button> -->
        </div>
      </b-modal>

      <b-modal id="serviceReview-modal" title="Service Review" hide-footer>
        <ServiceReview :productId="productId" />
      </b-modal>

      <b-modal id="shippingAddressFormModal" no-title hide-footer>
        <ShippingAddressForm
          @shipping-data="saveShippingData"
          @open-modal="showNextModal"
        />
      </b-modal>
    </div>
    <!--end of Multiple modal-->
  </div>
</template>

<script>
import axios from 'axios'
// import ProductReviews from '@/components/ui/ProductReviews.vue'
// import FrontProductCard from '@/components/ui/FrontProductCard.vue'
import AddToCart from '@/components/layout/AddToCart.vue'
import ShipToBtn from '@/components/layout/ShipToBtn.vue'
import { mapState } from 'vuex'
import LogInPage from '@/pages/LogInPage.vue'
import SignUpUser from '@/pages/SignUpUser.vue'
import StripePayment from '@/components/ui/StripePayment.vue'
import CheckMarkAnimTC from '@/components/common/CheckMarkAnimTC.vue'
import CheckMarkAnim18 from '@/components/common/CheckMarkAnim18.vue'
import InfoAnimButton from '@/components/layout/InfoAnimButton.vue'
import SuccessTickIconAnim from '@/components/common/SuccessTickIconAnim.vue'
import ServiceReview from '@/components/ui/ServiceReview.vue'
import ShippingAddressForm from '@/components/forms/ShippingAddressForm.vue'
import moment from 'moment'
import publicIpAddress from 'public-ip'

export default {
  components: {
    // ProductReviews,
    // FrontProductCard,
    AddToCart,
    ShipToBtn,
    LogInPage,
    SignUpUser,
    StripePayment,
    CheckMarkAnimTC,
    CheckMarkAnim18,
    SuccessTickIconAnim,
    InfoAnimButton,
    ServiceReview,
    ShippingAddressForm
  },
  data() {
    return {
      productData: null,
      errored: false,
      loading: true,
      price: '0',
      isChckoutLogin: true,
      isChckoutRegister: true,
      showLogin: true,
      cartData: [],
      allowToSell: true,
      totalPrice: 0,
      isItemAvailable: true,
      isCartAlcoholic: false,
      paymentResponse: {},
      disablePaymentFromDisclaimer: false,
      disablePaymentDisclaimerCommon: true,
      subscription: {},
      isProductVideoAvailable: false,
      isYouTubeVideo: false,
      videoUrl: null,
      baseUrl: process.env.VUE_APP_API_URL,
      type: {},
      showSuccessCheckmark: false,
      unitId: 0,
      productId: 0,
      isReviewGiven: false,
      shippingRate: null,
      flow: 'non-shippable',
      shippingDetails: null,
      itemsAvailability: []
    }
  },
  methods: {
    saveShippingData(response) {
      this.shippingDetails = response.data
    },
    paymentSucceed() {
      this.$bvModal.hide('success-modal')
      if (!this.isReviewGiven) {
        this.$bvModal.show('serviceReview-modal')
      }
    },
    async loginResponse() {
      this.$bvModal.hide('loginModal')
      if (this.type.flow === 'shippable')
        this.showNextModal({
          type: 'shippingAddressFormModal',
          flow: this.type.flow
        })
      else this.showNextModal({ type: 'miniCart', flow: this.type.flow })
    },
    async commonAPICalls(res) {
      await this.$store.dispatch('addToCart', this.createCartItemBody(res))
      this.cartData = await this.$store.dispatch('getFromCart')
      this.itemsAvailability = new Array(this.cartData.length)
      const alcoholicItem = this.cartData.filter(item => {
        this.type.flow = res.flow = 'non-shippable'
        if (item.delivery_type === 'shipping')
          this.type.flow = res.flow = 'shippable'
        return item.type && item.type.toLowerCase().trim() === 'alcoholic'
      })
      this.isCartAlcoholic = alcoholicItem.length > 0 ? true : false
      this.enablePaymentFromDisclaimer = alcoholicItem.length > 0 ? true : false
      this.isReviewGiven = await this.$store.dispatch(
        'order/fetchReviewDetails'
      )
      if (this.type.flow === 'shippable')
        this.$bvModal.show('shippingAddressFormModal')
      else this.$bvModal.show('miniCart')
    },
    async showNextModal(res) {
      switch (res.flow) {
        case 'shippable':
          this.shippableFlow(res)
          break
        case 'non-shippable':
          this.nonShippableFlow(res)
          break
      }
    },
    async shippableFlow(res) {
      switch (res.type) {
        case 'loginModal':
          this.type = res
          this.$bvModal.show(res.type)
          break
        case 'shippingAddressFormModal':
          this.type = res
          this.$bvModal.show(res.type)
          break
        case 'miniCart':
          this.type = res
          await this.commonAPICalls(res)
          this.shippingRate =
            this.type.flow === 'shippable' ? await this.getShippingRate() : null
          this.$bvModal.show(res.type)
          break
      }
    },
    async getShippingRate() {
      try {
        const shippingRate = await this.$store.dispatch(
          'order/getShippingRates',
          this.cartData[0].cart_id
        )
        if (shippingRate && shippingRate.estimated_delivery_date) {
          shippingRate.delivery_date = moment(
            shippingRate.estimated_delivery_date
          ).format('DD MMM YYYY')
        }
        return shippingRate
      } catch (error) {
        alert(this.$t('tryLater'))
        throw error
      }
    },
    addDays(date, days) {
      const result = new Date(Number(date))
      result.setDate(result.getDate() + days)
      return result
    },
    async nonShippableFlow(res) {
      switch (res.type) {
        case 'loginModal':
          this.type = res
          this.$bvModal.show(res.type)
          break
        case 'shippingAddressFormModal':
          break
        case 'miniCart':
          this.type = res
          this.commonAPICalls(res)
          this.$bvModal.show(res.type)
          break
      }
    },
    registerResponse() {
      this.showLogin = true
    },
    async showSuccessModal(response) {
      const self = this
      await axios
        .get(
          `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
        )
        .then(async response => {
          this.productData = response.data
        })
      this.paymentResponse = response
      this.$bvModal.hide('checkout-modal')
      this.$bvModal.show('success-modal')
      setTimeout(function() {
        self.showSuccessCheckmark = true
      }, 1000)
    },
    showRegister() {
      this.showLogin = false
    },
    showLoginPage() {
      this.showLogin = true
    },
    enablePayment(enblePaymentflag) {
      this.disablePaymentFromDisclaimer = !enblePaymentflag
    },
    enablePaymentCommon(enblePaymentflag) {
      this.disablePaymentDisclaimerCommon = !enblePaymentflag
    },
    async showShippingAddressFormModal() {
      this.$bvModal.show('shippingAddressFormModal')
    },
    setTimerForUrlExpiry() {
      setTimeout(() => {
        this.$router.replace({ name: 'expired' })
      }, 1800000) // url timeout in miliseconds
    },
    createCartItemBody(res) {
      return {
        unit_id: this.unitId,
        product_id: this.productId,
        quantity: 1,
        delivery_type: res.flow === 'shippable' ? 'shipping' : 'self-service',
        first_time_add: true
      }
    },
    async openCheckoutModal() {
      this.$bvModal.hide('miniCart')
      if (this.cartData.length === 0) {
        alert('Need at least one item to do checkout')
        return
      } else {
        const timeResponse = await this.getTime()
        if (timeResponse.hour >= 21 || timeResponse.hour <= 6) {
          const typeResult = this.checkAlcoholicProduct()
          if (
            typeResult.hasAlcoholicProduct === true &&
            typeResult.hasNonAlcoholicProduct === true
          ) {
            alert('Please remove alcoholic product to complete the purchase')
            return
          } else if (typeResult.hasAlcoholicProduct === true) {
            alert('Please try one more time after 7 am')
            return
          }
        }
        await this.calculateTotalPrice()
        this.$bvModal.show('checkout-modal')
        await this.updateQuantityInCartItems()
      }
    },
    checkAlcoholicProduct() {
      let hasAlcoholicProduct = false
      let hasNonAlcoholicProduct = false
      this.cartData.forEach(cartItem => {
        if (cartItem.type === 'alcoholic') {
          hasAlcoholicProduct = true
        } else {
          hasNonAlcoholicProduct = true
        }
      })
      return { hasAlcoholicProduct, hasNonAlcoholicProduct }
    },
    async updateQuantityInCartItems() {
      for (const item of this.cartData) {
        await this.$store.dispatch('addToCart', {
          unit_id: item.unit_id,
          product_id: item.product_id,
          quantity: item.quantity,
          delivery_type: item.delivery_type
        })
      }
    },
    async updateCartItem(item) {
      await this.$store.dispatch('addToCart', {
        unit_id: item.unit_id,
        product_id: item.product_id,
        quantity: item.quantity,
        delivery_type: item.delivery_type
      })
    },
    calculateTotalPrice() {
      this.totalPrice = 0
      this.cartData.forEach(cartItem => {
        this.totalPrice += +cartItem.price * +cartItem.quantity
      })
      if (this.shippingRate)
        this.totalPrice = this.totalPrice + +this.shippingRate.shipping_cost
      this.totalPrice = Number(this.totalPrice.toFixed(2))
    },
    decreaseValue(index) {
      if (this.cartData[index].quantity > 1) {
        this.cartData[index].quantity = this.cartData[index].quantity - 1
        this.updateCartItem(this.cartData[index])
        this.isItemAvailable = true
        this.itemsAvailability[index] = true
        this.itemsAvailability = JSON.parse(
          JSON.stringify(this.itemsAvailability)
        )
      }
    },
    async increaseValue(index) {
      const quantity = this.cartData[index].quantity
      const stockResponse = await this.$store.dispatch('checkStock', {
        unit_id: this.unitId,
        product_id: this.cartData[index].product_id,
        quantity: quantity + 1
      })
      if (stockResponse) {
        this.cartData[index].quantity = quantity + 1
        this.updateCartItem(this.cartData[index])
        this.itemsAvailability[index] = true
        this.itemsAvailability = JSON.parse(
          JSON.stringify(this.itemsAvailability)
        )
      } else {
        this.isItemAvailable = false
        this.itemsAvailability[index] = false
        this.itemsAvailability = JSON.parse(
          JSON.stringify(this.itemsAvailability)
        )
      }
    },
    removeItem(itemId, index) {
      if (confirm('Are you sure? This item will be removed from cart')) {
        this.$store.dispatch('removeFromCart', itemId).then(async () => {
          this.cartData = await this.$store.dispatch('getFromCart')
          this.itemsAvailability.splice(index, 1)
          let shippableItem = false
          this.cartData.forEach(item => {
            if (item.delivery_type === 'shipping') shippableItem = true
          })
          this.shippingRate = shippableItem ? this.shippingRate : null
          const alcoholicItem = this.cartData.filter(item => {
            return item.type && item.type.toLowerCase().trim() === 'alcoholic'
          })
          this.isCartAlcoholic = alcoholicItem.length > 0 ? true : false
        })
      }
    },
    youtubeParser(url) {
      const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
      const match = url.match(regExp)
      return match && match[7].length == 11 ? match[7] : false
    },
    async getTime() {
      const publicIp = await publicIpAddress.v4()
      return new Promise((resolve, reject) => {
        this.$store
          .dispatch('timeapi', publicIp)
          .then(response => {
            const datetime = response.data
            return resolve(datetime)
          })
          .catch(error => {
            return reject(error)
          })
      })
    },
    callBackToMyBag() {
      this.$bvModal.hide('checkout-modal')
      this.$bvModal.show('miniCart')
    },
    performBeforeOpenBag() {
      this.isItemAvailable = true
      if (this.type.flow === 'non-shippable') {
        this.shippingRate = null
      }
    }
  },
  async mounted() {
    this.setTimerForUrlExpiry()
    this.subscription = await this.$store.dispatch(
      'fetchSubscriptionDetails',
      this.$route.params.productUUID
    )
    await axios
      .get(
        `${process.env.VUE_APP_API_URL}/unitStore/unit/${this.$route.params.unitUUID}/product/${this.$route.params.productUUID}`
      )
      .then(async response => {
        this.productData = response.data
        this.unitId = this.productData.unit_Id
        this.productId = this.productData.product_Id
        const timeResponse = await this.getTime()
        if (
          response.data.type &&
          response.data.type.toLowerCase().trim() === 'alcoholic' &&
          (timeResponse.hour >= 21 || timeResponse.hour <= 6)
        ) {
          this.allowToSell = false
          alert('Not allowed to sell after 9 pm. Try again tomorrow from 7 am')
        }

        if (
          this.productData.productVideo &&
          this.productData.productVideo.includes('youtu')
        ) {
          this.isYouTubeVideo = true
          this.videoUrl = this.youtubeParser(this.productData.productVideo)
        } else {
          this.isYouTubeVideo = false
          // axios
          //   .get(`${this.productData.productVideo}`)
          //   .then(() => {
          //     this.isProductVideoAvailable = true
          //     document.getElementById('vid').play()
          //     console.log(document.getElementById('vid'))
          //   })
          //   .catch(() => {
          //     this.isProductVideoAvailable = false
          //   })
        }
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      })
      .finally(() => (this.loading = false))
    // await this.$store.dispatch('addToCart', this.createCartItemBody())
    // this.cartData = await this.$store.dispatch('getFromCart')
  },
  props: {},
  computed: mapState(['product', 'client', 'cart'])
}
</script>

<style lang="scss">
.trashIcon {
  background: var(--gray);
  color: var(--bright) !important;
  padding: 12px;
  border: none !important;
  border-radius: 5px;
  margin-left: 10px;
  display: inline;
  position: absolute;
}

.icon {
  font-size: 1.3em;
}
.media-body {
  text-align: left;
  margin-left: 10px;
  margin-bottom: 30px;
}
.media-body h5 {
  font-size: 1.3em;
  font-weight: 600;
}
.media-body form {
  text-align: left;
  margin: 0;
}

.productName {
  font-size: 1.5em;
}

.trashIcon:active {
  background: var(--bg);
}

.left {
  text-align: left;
  font-size: 0.85em;
  margin-bottom: 2em;
}
.totalPriceLeft {
  text-align: left;
}

.totalPrice {
  font-size: 2.3rem;
  font-weight: 600;
  margin-left: 10px;
}
.totalPrice2 {
  font-size: 0.8rem;
  font-weight: 600;
}

#example-1 li {
  list-style-type: none;
}

.background-wrapper {
  scroll-behavior: smooth;
}
.stock-info-text {
  color: var(--bg) !important;
}
.out-of-stock-info-text {
  color: var(--alert) !important;
}
.stock-info-text-cart {
  color: black;
}
.shipping-info {
  color: var(--bg) !important;
  display: block;
  text-align: left;
}
.colorLink {
  color: var(--bg) !important;
}
.colorLink:hover {
  color: var(--primary) !important;
}
.colorLink:active {
  color: var(--primary) !important;
}
#loginModal .modal-header .close {
  padding: 1rem 1rem;
  position: absolute;
}
#loginModal .modal-header {
  // border-bottom: none;
  padding: 1rem 5rem 1rem 1rem !important;
}

#loginModal .modal-title {
  margin-left: 50px;
}

#miniCart .modal-header {
  padding: 1rem 5rem 1rem 2rem !important;
}
#miniCart .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem;
  margin-bottom: 0px;
  position: absolute;
}
#miniCart .modal-title {
  margin-left: 40px;
}
#miniCart .modal-content {
  height: inherit;
}

#continueShopping .modal-header .close {
  padding: 1rem 1rem;
  position: absolute;
}

#continueShopping .modal-header {
  // border-bottom: none;
}
#continueShopping .modal-title {
  margin-left: 50px;
}

#continueShopping .modal-content {
  height: inherit;
}
#continueShopping h4 {
  margin-top: 5em;
}

#checkout-modal .modal-header {
  padding: 1rem 5rem 1rem 2rem !important;
}
#checkout-modal .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem;
  margin-bottom: 0px;
  position: absolute;
}
#checkout-modal .modal-title {
  margin-left: 40px;
}
#checkout-modal .modal {
  padding: 0px !important;
}

#shippingAddressFormModal .modal-header {
  padding: 1rem 5rem 1rem 2rem !important;
  border-bottom: none;
}
#shippingAddressFormModal .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem;
  position: absolute;
}
#shippingAddressFormModal .modal-title {
  margin-left: 40px;
}

#serviceReview-modal .modal {
  padding-left: 0px !important;
}

#serviceReview-modal .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem;
  margin-bottom: 0px;
  position: absolute;
}
#serviceReview-modal .modal-title {
  margin-left: 40px;
}

#success-modal .modal-header .close {
  padding: 1rem 1rem;
  margin: -1rem -1rem -1rem;
  margin-bottom: 0px;
  position: absolute;
}
#success-modal .modal-title {
  margin-left: 40px;
}

#scroll {
  position: fixed;
  background: #373a47;
  padding: 5px;
  border-radius: 3px;
  bottom: 80px;
  right: 40px;
  text-align: center;
  z-index: 2000;
  color: #fafbfc;
}
#cta-sticky {
  position: fixed;
  background-color: $primary-dark;
  width: 100%;
  height: 70px;
  text-align: center;
  z-index: 250;
  bottom: 0px;
}
// .rating {
//   text-align: left;
//   padding-left: 40px;
// }
.ratingNo {
  font-size: 25px;
  font-weight: 600;
}
.description_text {
  padding: 30px;
  white-space: normal;
  text-align: justify;
}
.price-details {
  padding-left: 50px;
  padding-bottom: 30px;
  text-align: left;
}
.price {
  font-size: 40px;
  font-weight: 700;
}
.valuta {
  font-size: 27px;
  font-weight: 700;
}
.tax-details {
  font-size: 12px;
  font-weight: 400;
}
.secondary-gradient {
  background-color: linear-gradient(
    200deg,
    rgba(251, 115, 119, 1) 29% rgba(201, 92, 95, 1) 59
  );
}
.myBagImg {
  max-width: 120px;
}
.mg-b50 {
  margin-bottom: 80px;
}
.media {
  margin-bottom: 2em;
}
.disclaimer {
  position: relative;
}
.notShippable {
  width: 100% !important; // width: 100%; when product is NOT shippable !!!! //
}
.scanBuy {
  float: left;
  width: 50%;
}
.shipTo {
  float: right;
  width: 35%;
}
.secondary-gradient {
  width: 80%;
}
.product_title {
  font-size: 35px;
  font-weight: 100;
  text-transform: uppercase;
}

.colorLink {
  color: var(--bg) !important;
  text-decoration: underline;
}
.colorLink:hover {
  color: var(--primary) !important;
}
.colorLink:active {
  color: var(--primary) !important;
}

.stripeIcon {
  width: 100%;
  max-width: 150px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.stripeCards {
  width: 70%;
  margin: 20px;
  margin-top: 10px;
}
.stripeTrustBadge {
  margin-top: 40px;
  color: #32364e;
}

.divider {
  margin-bottom: 20px;
  margin-top: 20px;
  margin-left: 20px;
  margin-right: 20px;
}

.intro_content {
  margin-top: -15rem;
  z-index: 0;
}
.container {
  max-width: 100%;
  width: 100%;
  padding-right: 0rem;
  padding-left: 0rem;
  margin-right: auto;
  margin-left: auto;
}
.intro__title {
  position: relative;
  z-index: 110;
}
.heading-one {
  font-size: 4rem;
}
.text-light {
  color: #fff !important;
  line-height: 100%;
}
.mb-0 {
  margin-bottom: 0 !important;
}
.intro__video {
  margin-top: -2rem;
}
.video-container {
  display: -webkit-box;
  display: flex;
  flex-wrap: wrap;
  margin-right: 0px;
  margin-left: 0px;
  margin-top: 20px;
}
.video-teaser {
  position: relative;
  cursor: pointer;
  z-index: 100;
  height: 200px;
  width: 100%;
}

::v-deep .hide-padding {
  padding: 0;
}

form {
  width: 300px;
  margin: 0 auto;
  text-align: center;
  padding-top: 20px;
  margin-bottom: 2em;
}

.value-button {
  display: inline-block;
  border: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  text-align: center;
  vertical-align: middle;
  padding: 11px 0;
  background: #eee;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.value-button:hover {
  cursor: pointer;
}

form #decrease {
  margin-right: -4px;
  border-radius: 8px 0 0 8px;
}

form #increase {
  margin-left: -4px;
  border-radius: 0 8px 8px 0;
}

form #input-wrap {
  margin: 0px;
  padding: 0px;
}

input#number {
  text-align: center;
  border: none;
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  margin: 0px;
  width: 40px;
  height: 40px;
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

//CTA button css //
.cta-button {
  background: linear-gradient(to right, #fb7377, #c95c5f);
  width: 250px;
  color: white;
  margin-top: 5px;
  margin-bottom: 50px;
  align-items: center;
  justify-content: space-between;
  height: 52px;
  border: none;
  border-radius: 5px;
  font-size: 1.4em;
  text-align: center;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  font-weight: 500;
  white-space: nowrap;
  transition: all 0.2s linear;
}

.cta-button:hover {
  transform: scale(1);
  box-shadow: none;
  background: linear-gradient(to right, #f7921ec9, #c46428a8);
}

.cta-button:active {
  animation: pulse 0.25s infinite ease-out;
}

.cta-button:focus {
  outline: 0;
}
.cta-button:disabled {
  -webkit-transform: scale(1);
  transform: scale(1);
  box-shadow: none;
}

@keyframes pulse {
  0% {
    transform: scale(0.9);
  }
  40% {
    transform: scale(1);
  }
  80% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.9);
  }
}

.logout_btn {
  padding: 10px;
  width: 250px;
  background: var(--bg-light);
  text-decoration: none;
  margin-top: -20px;
  border-radius: 5px;
  font-size: 16px;
  font-weight: 100;
  color: var(--white);
  transition: 0.5s;
  transition-property: background;
  letter-spacing: 2px;
}

.logout_btn:hover {
  background: #49535e;
}
//----end of CTA buton --//

.about-img2 {
  display: inline-block;
  width: 100%;
  margin-top: -20px;
  max-width: 200px;
  text-align: center;
  vertical-align: top;
}

// media queries for common device breakpoints

//Galaxy Fold //
@media only screen and (min-device-width: 270px) and (max-device-width: 280px) {
  .intro_content {
    margin-top: -18rem;
  }
  .heading-one {
    font-size: 2.4em;
  }
}
//
@media only screen and (min-device-width: 281px) and (max-device-width: 320px) {
  .intro_content {
    margin-top: -22rem;
  }
  .heading-one {
    font-size: 2.6em;
  }
}
//iPhone 5 //
@media only screen and (min-device-width: 321px) and (max-device-width: 359px) and (orientation: portrait) {
  .intro_content {
    margin-top: -30rem;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 320px) and (max-device-width: 568px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .intro_content {
    margin-top: -25rem;
  }
  .heading-one {
    font-size: 2.5em;
  }
  .product-info {
    margin-top: 18rem;
  }
  .description_text {
    padding: 30px 60px;
  }
  .product_title {
    padding: 0 50px;
  }
  #continueShopping h4 {
    margin-top: 0em !important;
    padding: 0 15px;
  }
  #miniCart .modal-content {
    height: 130vh;
  }
  .cta-btn {
    margin: 0 10px 25px 10px;
    height: 55px;
  }
  .logout-btn {
    margin: 0 10px 44px 10px;
  }
}

//Galaxy S5/S8/Moto S4  and Note 3//
@media only screen and (min-device-width: 360px) and (max-device-width: 374px) and (orientation: portrait) {
  .intro_content {
    margin-top: -20rem;
  }
  .heading-one {
    font-size: 3em;
  }
  .product_title {
    padding: 0 17px;
  }
}
@media screen and (device-width: 320px) and (device-height: 640px) and (-webkit-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -26rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 10rem;
  }
  .description_text {
    padding: 30px 100px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: 5px;
  }
  #continueShopping h4 {
    margin-top: 1em !important;
  }
}

//iPhone 6/7/8/X/11Pro/12 Mini //
@media only screen and (min-device-width: 375px) and (max-device-width: 389px) and (orientation: portrait) {
  .intro_content {
    margin-top: -18rem;
  }
  .heading-one {
    font-size: 3.2em;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -23rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 25rem;
  }
  .description_text {
    padding: 30px 130px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: -30px;
  }
  #continueShopping h4 {
    margin-top: 1em !important;
  }
}
//iPhone 12/12Pro //
@media only screen and (min-device-width: 390px) and (max-device-width: 413px) and (orientation: portrait) {
  .intro_content {
    margin-top: -20rem;
  }
  .heading-one {
    font-size: 3.4em;
  }
}
/* ----------- iPhone 6, 6S, 7 and 8 ----------- */

/* Portrait */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait) {
}

/* Landscape */
@media only screen and (min-device-width: 375px) and (max-device-width: 667px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  #continueShopping h4 {
    margin-top: 0.5em !important;
    padding: 0 15px;
  }
  #miniCart .modal-content {
    height: 130vh;
  }
}
//iPhone 6/7/8 Plus/11 //
@media only screen and (min-device-width: 414px) and (max-device-width: 440px) and (orientation: portrait) {
  .intro_content {
    margin-top: -16rem;
  }
  .heading-one {
    font-size: 3.6em;
  }
  .product_title {
    padding: 0 20px;
  }
}
@media only screen and (min-device-width: 414px) and (max-device-width: 736px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  .intro_content {
    margin-top: -23rem;
  }
  .heading-one {
    font-size: 3.5em;
  }
  .product-info {
    margin-top: 25rem;
  }
  .description_text {
    padding: 30px 130px;
  }
  .product_title {
    padding: 0 50px;
  }
  .video-teaser {
    left: 0px;
  }
  #continueShopping h4 {
    margin-top: 1em !important;
  }
  #miniCart .modal-content {
    height: 110vh;
  }
}

/* ----------- iPhone X ----------- */

/* Portrait */
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: portrait) {
}

/* Landscape */
@media only screen and (min-device-width: 375px) and (max-device-width: 812px) and (-webkit-min-device-pixel-ratio: 3) and (orientation: landscape) {
  #miniCart .modal-content {
    height: 120vh;
  }
}

/* ----------- iPad 1, 2, Mini and Air ----------- */

/* Portrait and Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 1) {
}

/* Portrait */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 1) {
}

/* Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 1) {
}

/* ----------- iPad 3, 4 and Pro 9.7" ----------- */

/* Portrait and Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) {
}

/* Portrait */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
}

/* Landscape */
@media only screen and (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
}

/* ----------- iPad Pro 10.5" ----------- */

/* Portrait and Landscape */
@media only screen and (min-device-width: 834px) and (max-device-width: 1112px) and (-webkit-min-device-pixel-ratio: 2) {
}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen and (min-device-width: 834px) and (max-device-width: 834px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen and (min-device-width: 1112px) and (max-device-width: 1112px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
}

/* ----------- iPad Pro 12.9" ----------- */

/* Portrait and Landscape */
@media only screen and (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
  .cta-button {
    margin-bottom: 25px;
    margin-right: 10px;
  }
  .logout_btn {
    height: 52px !important;
  }
}

/* Portrait */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen and (min-device-width: 1024px) and (max-device-width: 1024px) and (orientation: portrait) and (-webkit-min-device-pixel-ratio: 2) {
}

/* Landscape */
/* Declare the same value for min- and max-width to avoid colliding with desktops */
/* Source: https://medium.com/connect-the-dots/css-media-queries-for-ipad-pro-8cad10e17106*/
@media only screen and (min-device-width: 1366px) and (max-device-width: 1366px) and (orientation: landscape) and (-webkit-min-device-pixel-ratio: 2) {
}

@media (max-width: 1920px) and (min-width: 1080px) {
  // You're assuming the screen's maximal width to be 1920,
  // and it's minimal width to be 1080px, which means this CSS
  // is applied when the screen's width is 1080px or more,
  // but less than 1920px;

  .logo1 {
    margin-top: 70%;
  }

  .socmed a:nth-child(1),
  .socmed a:nth-child(2) {
    margin-top: 100%;
  }
}

//  CSS media queries to target Apple's 2019 and 2020 devices

// iPhone 12 Mini, iPhone 11 Pro, iPhone Xs, and iPhone X
// @media only screen
//     and (device-width: 375px)
//     and (device-height: 812px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 12 and iPhone 12 Pro
// @media only screen
//     and (device-width: 390px)
//     and (device-height: 844px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 12 Pro Max
// @media only screen
//     and (device-width: 428px)
//     and (device-height: 926px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 11 and iPhone XR
// @media only screen
//     and (device-width: 414px)
//     and (device-height: 896px)
//     and (-webkit-device-pixel-ratio: 2) { }

//  iPhone 12 Mini, iPhone 11 Pro, iPhone Xs, and iPhone X
//  @media only screen
//     and (device-width: 375px)
//     and (device-height: 812px)
//     and (-webkit-device-pixel-ratio: 3) { }

// iPhone 11 Pro Max and iPhone Xs Max
// @media only screen
//     and (device-width: 414px)
//     and (device-height: 896px)
//     and (-webkit-device-pixel-ratio: 3) { }
</style>
